import {
    IFetchDataStrategy,
    StoreLocatorFetchDataStrategy
} from '../strategies/StoresFetchDataStrategies';

export interface IPanOptions {
    centerLat: number;
    centerLng: number;
}

export class PannedOnMapUseCase {
    private options: IPanOptions;
    private fetchDataStrategy: IFetchDataStrategy;

    constructor(
        options: IPanOptions,
        fetchDataStrategy: IFetchDataStrategy = new StoreLocatorFetchDataStrategy()
    ) {
        this.options = options;
        this.fetchDataStrategy = fetchDataStrategy;
    }

    public execute = async () => {
        const geolocation = {
            lat: this.options.centerLat,
            lng: this.options.centerLng
        };

        await this.fetchDataStrategy.loadStores(geolocation);
    };
}
